module.exports = __webpack_public_path__ + "static/ACCEPTABLE USE POLICY -7e628cc9a9cd636ed5f6a03b2f609896.pdf";